import { Component, Input, OnInit } from "@angular/core";
import { TableColumn } from "@mynexus/mynexus-ui-lib";
import { CaseStatus } from "../models/case-status";

@Component({
  selector: 'app-case-status',
  templateUrl: './case-status.component.html',
  styleUrl: './case-status.component.scss',
  standalone: false
})
export class CaseStatusComponent implements OnInit {
  readonly rows = 5;

  @Input() memberId!: string;
  @Input() tenantId: string;

  cols: TableColumn[] = [
    new TableColumn('', '', '3rem', 'table-cell'),
    new TableColumn('Case ID', 'caseId', '10rem', 'table-cell'),
    new TableColumn('Update Received Date/Time', 'updateReceivedDateTime', '16rem', 'table-cell'),
    new TableColumn('Case Status', 'caseStatus', '10rem', 'table-cell'),
    new TableColumn('Program Reason for Management', 'programReasonForManagement', '18rem', 'table-cell'),
    new TableColumn('Case Owner/Team', 'caseOwnerTeam', '14rem', 'table-cell'),
    new TableColumn('RFM Risk Level', 'rfmRiskLevel', '10rem', 'table-cell'),
  ];
  data: CaseStatus[] = [];
  expandedRows: { [key: string]: boolean } = {};
  selectedRow: CaseStatus | null = null;

  constructor() { }

  ngOnInit(): void {
  }
}
